import React, { useMemo, useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import ModalHeader from './Content/ModalHeader'
import { eventDetailsStore } from 'state/event/eventDetails'
import { EventResp } from 'types/event/events'
import SelectDateFromGivenDates from 'components/global/SelectDateFromGivenDates'
import Participants from './Content/Participants'
import { AttendeeStatusParams } from 'types/event/eventAttendance'
import { convertToUtc } from 'helper/utility'
import ExportCheckInOutModal from '../ExportCheckInOutModal'
import RollCalls from './Content/RollCalls'

const CheckInOutModal = () => {
  // global states
  const {
    checkInOutModalOpen,
    setCheckInOutModalOpen,
    checkInOutExportModalOpen,
    selectedDate,
    setSelectedDate,
  } = eventAttendanceStore(store => ({
    checkInOutModalOpen: store.checkInOutModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    checkInOutExportModalOpen: store.checkInOutExportModalOpen,
    selectedDate: store.selectedDate,
    setSelectedDate: store.setSelectedDate,
  }))
  const eventDetails: EventResp = eventDetailsStore(
    store => store.eventDetailedData,
  )
  // const [selectedDate, setSelectedDate] = useState<Date>(new Date())

  const [params, setParams] = useState<AttendeeStatusParams>({
    eventId: eventDetails._id,
    date: convertToUtc(selectedDate),
  })

  const [currentView, setCurrentView] = useState<'particpants' | 'roll-calls'>(
    'particpants',
  )

  useMemo(() => {
    setParams(prev => ({ ...prev, date: convertToUtc(selectedDate) }))
  }, [selectedDate])

  const closeMdoal = () => {
    setSelectedDate(new Date())
    setCheckInOutModalOpen(false)
  }

  return (
    <>
      <CustomModal
        openModal={checkInOutModalOpen}
        isCloseModalCustom
        closeModal={closeMdoal}
        title="Check-in/Out"
        width={1200}
        footer={false}
      >
        <>
          <div>
            <ModalHeader
              params={params}
              setParams={setParams}
              currentView={currentView}
              setView={setCurrentView}
            />

            <div className="flex justify-between gap-100px">
              <div className="flex-1 overflow-auto">
                {currentView === 'particpants' ? (
                  <Participants params={params} />
                ) : currentView === 'roll-calls' ? (
                  <RollCalls params={params} />
                ) : null}
              </div>

              <div>
                <SelectDateFromGivenDates
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  availableDates={eventDetails.datesOfEvent}
                />
              </div>
            </div>
          </div>

          {checkInOutExportModalOpen && (
            <ExportCheckInOutModal params={params} />
          )}
        </>
      </CustomModal>
    </>
  )
}

export default CheckInOutModal
